<template>
    <div class="body-inner">
        <header-component></header-component>
        <section id="page-title" style="height: 400px;">
            <div class="container">
                <div class="page-title">
                
                <div class="row">
                
                <div class="col-md-6">
                    <h2 class="text-secondary">Bienvenido al catálogo<br>de soluciones GCA</h2></div>
                 <div class="col-md-6">
                 
                   <h3>¿Eres estudiante, docente o directivo en una institución académica?</h3>
                       <p>Conoce los beneficios que tenemos para ti:</p>
                        <a class="btn" data-target="#modal" data-toggle="modal" href="#">Haz clic</a>
                        

                 
                 
                 </div><!--col5-->  
                    
                    
                 </div>
                    
                </div>
                
            </div>
        </section>

        <!-- Shop products -->
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-4" v-for="producto in productosCatalogo" :key="producto.id">
                        <div class="card">
                            <img class="card-img-top" :src="producto.imagen_store">
                            <div class="card-body">
                                <h5 class="card-title">{{ producto.nombre }}</h5>
                                <p class="card-text">{{ producto.descripcion }}</p>
                                <router-link :to="`/detalle-producto/${producto.id}`" class="btn btn-xs btn-primary">Ver detalles</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Footer -->
        <footer id="footer">
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; 2023 <a href="https://etciberoamerica.com/" target="_blank" rel="noopener">Global Certification Academy.</a> </div>
                </div>
            </div>
        </footer>
        <!-- end: Footer -->
    </div>
</template>

<script>
/* eslint-disable */
import HeaderComponent from '../../components/Store/HeaderComponent'
export default {
    name: 'Productos',
    components: {
    HeaderComponent
    },
    data() {
        return {
            productosCatalogo: [],
            hostname: '',
        }
    },

    methods: {

    },
    async mounted() {
        this.openLoading()
        await this.getProductosStore('api/productos?aparece_index=1')
        Swal.close()
    },
    beforeDestroy() {
    }
}
</script>
<style lang="css" scoped src="../../assets/css/pluginsStore.css"></style>
<style lang="css" scoped src="../../assets/css/style.css"></style>